import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { withDefaults } from 'vue';

interface IProps {
  title: string;
  classes?: string[];
  noMargin?: boolean;
  fontSize?:string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomTitle',
  props: {
    title: null,
    classes: null,
    noMargin: { type: Boolean },
    fontSize: null
  },
  setup(__props: any) {

const props = __props as { title: string, classes?: string[], noMargin?: boolean, fontSize?:string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h1", {
    style: _normalizeStyle({ marginBottom: __props.noMargin ? 0 : '16px', fontSize: __props.fontSize? __props.fontSize:'' }),
    class: _normalizeClass(__props.classes)
  }, _toDisplayString(props.title), 7))
}
}

})